import format from 'date-fns/format';
import fromUnixTime from 'date-fns/fromUnixTime';
import { Heading } from '@chakra-ui/react';

import useDateFnsLocale from '@lib/hooks/useDateFnsLocale';

import { TEXT_COLOR } from '../../layouts/EventLayout';

type Props = {
  startedAt: number;
  endedAt: number;
};
const EventDateTime = ({ startedAt, endedAt }: Props) => {
  const dateFnsLocale = useDateFnsLocale();

  const eventDate = `${format(new Date(fromUnixTime(startedAt)), 'PP (ccc)', {
    locale: dateFnsLocale,
  })}`;

  const eventTime = `${format(new Date(fromUnixTime(startedAt)), 'p', {
    locale: dateFnsLocale,
  })}
- ${format(new Date(fromUnixTime(endedAt)), 'p', {
    locale: dateFnsLocale,
  })}`;

  return (
    <Heading
      color={TEXT_COLOR}
      fontSize="18px"
      lineHeight="34px"
      fontWeight="700"
      ml="2"
    >
      {eventDate} {eventTime}
    </Heading>
  );
};

export default EventDateTime;
